import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Config } from "../_store";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class InvoiceService {
  invoice: any;
  invoiceFile: any;
  fileElement: any;
  documents: any;
  invoiceType: any;
  invType: any;
  noteType: any;
  fileUrl: any;
  nonPOFields: any;
  digitalInvoiceData: any;
  username: any;
  userId: any;
  logisticsPoNumber: any;
  config: Object;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) {}

  /** Check if object has property */

  hasProperty(obj: any, propertyPath: string, newProperty: string): any {
    const properties = propertyPath.split(".");
    let currentObj = obj;

    for (const property of properties) {
      if (Array.isArray(currentObj)) {
        for (const item of currentObj) {
          if (!item.hasOwnProperty(property)) {
            currentObj[newProperty] = false;
            return obj;
          }
          currentObj = item[property];
        }
      } else {
        if (!currentObj || !currentObj.hasOwnProperty(property)) {
          currentObj[newProperty] = false;
          return obj;
        }
        currentObj = currentObj[property];
      }
    }

    currentObj[newProperty] = true;
    return obj;
  }

  fecthInvoices(data: any) {
    return this.http.post(Config.urls.INVOICES, data);
  }

  extractInvoice(data: any) {
    return this.http.post(Config.urls.EXTRACTINVOICE, data);
  }

  getInvoiceDetails(data: any) {
    return this.http.post(Config.urls.GETINVOICEDETAILS, data);
  }

  uploadInvoice(data: any) {
    return this.http.post(Config.urls.SUBMITINVOICE, data);
  }

  uploadInvoiceWithoutExtration(data: any) {
    return this.http.post(Config.urls.SUBMITINVOICEWITHOUTEXTRACT, data);
  }

  saveInvoice(data: any) {
    return this.http.post(Config.urls.SAVEINVOICE, data);
  }

  verifyDigitalSignature(data: any) {
    //const compressedFormData = pako.gzip(JSON.stringify(data));
    return this.http.post(Config.urls.VERIFYSIGNATURE, data);
  }

  sendInvoiceToJSW(data: any) {
    return this.http.post(Config.urls.SUBMITINVOICETOJSW, data);
  }

  fetchConfig(data: any) {
    return this.http.post(Config.urls.FETCHCONFIG, data);
  }

  getConfig(data: any) {
    return this.http.post(Config.urls.GET_CONFIG, data);
  }

  fetchAllConfig(data: any) {
    this.http.post(Config.urls.GET_ALL_CONFIG, data).subscribe((res: any) => {
      this.config = res.data;
      this.storageService.add("config", JSON.stringify(this.config));
      console.log(this.config, "this.config");
    });
  }

  getAllConfig() {
    const config = this.storageService.get("config");
    if (config) {
      this.config = JSON.parse(config);
    }
    console.log(this.config, "this.config");
    return this.config;
  }

  fetchQueries(data: any) {
    return this.http.post(Config.urls.GETQUERY, data);
  }

  setProcessedInvoice(data: any) {
    console.log("setting processed invoice");
    this.invoice = data;
  }

  getProcessedInvoice() {
    return this.invoice;
  }

  setUsername(data: any) {
    this.username = data;
  }
  getUsername() {
    return this.username;
  }

  setPo(data: any) {
    this.logisticsPoNumber = data;
  }
  getPo() {
    return this.logisticsPoNumber;
  }

  setUserId(data: any) {
    this.userId = data;
  }

  getUserId() {
    return this.userId;
  }

  setInvoiceFile(file: any) {
    this.invoiceFile = file;
  }

  getInvoiceFile() {
    return this.invoiceFile;
  }

  setNonPOFields(fields: any) {
    this.nonPOFields = fields;
  }

  getNonPOFields() {
    return this.nonPOFields;
  }

  setFileElement(element: any) {
    this.fileElement = element;
  }

  getFileElement() {
    return this.fileElement;
  }

  setDocuments(element: any) {
    this.documents = element;
  }

  getDocuments() {
    return this.documents;
  }

  setInvType(type: any) {
    this.invType = type;
  }

  getInvType() {
    return this.invType;
  }

  setInvoiceType(type: any) {
    this.invoiceType = type;
  }

  getNoteType() {
    return this.noteType;
  }

  setNoteType(type: any) {
    this.noteType = type;
  }

  getInvoiceType() {
    return this.invoiceType;
  }

  setFileUrl(type: any) {
    this.fileUrl = type;
  }

  getFileUrl() {
    return this.fileUrl;
  }

  setDataDigitalInvoice(data: any) {
    this.digitalInvoiceData = data;
  }

  getDataDigitalInvoice() {
    return this.digitalInvoiceData;
  }
}
